import React from 'react';
import { Snowflake, Flame, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import { Button } from './ui/button';
import Pagination from './Pagination/Pagination';

function TicketTable({
  title,
  tickets,
  totalCount,
  currentPage,
  onPageChange,
  itemsPerPage,
  userInfo,
  onFreeze,
  onUnfreeze,
  onEdit,
  showActions = true,
  status,
}) {
  const { t } = useTranslation();

  const getStatusTranslation = estado => {
    const statusKey = estado.toLowerCase();
    return t(`ticket.status.${statusKey}`);
  };

  const renderActionButtons = ticket => {
    if (!showActions) return null;

    switch (status) {
      case 'disponible':
        return (
          <Button
            variant='ghost'
            size='icon-sm'
            title={t('ticket.freeze')}
            className='text-muted-foreground hover:text-foreground'
            onClick={() => onFreeze(ticket._id)}
          >
            <Snowflake className='h-4 w-4' />
          </Button>
        );
      case 'congelado':
        return (
          <Button
            variant='ghost'
            size='icon-sm'
            title={t('ticket.unfreeze')}
            className='text-muted-foreground hover:text-foreground'
            onClick={() => onUnfreeze(ticket._id)}
          >
            <Flame className='h-4 w-4' />
          </Button>
        );
      case 'vendido':
        return userInfo && userInfo.isSuperAdmin ? (
          <Button
            variant='ghost'
            size='icon-sm'
            title={t('common.edit')}
            className='text-destructive hover:text-destructive'
            onClick={() => onEdit(ticket)}
          >
            <Trash2 className='h-4 w-4' />
          </Button>
        ) : null;
      default:
        return null;
    }
  };

  return (
    <>
      <div className='px-4 py-3 text-sm font-medium text-foreground'>
        {title} ({totalCount})
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t('ticket.number')}</TableHead>
            <TableHead>{t('ticket.statusHeader')}</TableHead>
            <TableHead>{t('ticket.buyer')}</TableHead>
            <TableHead>{t('ticket.seller')}</TableHead>
            {showActions && <TableHead />}
          </TableRow>
        </TableHeader>
        <TableBody>
          {tickets.map(ticket => (
            <TableRow key={`ticket-${ticket._id}`}>
              <TableCell>{ticket.nroSerial}</TableCell>
              <TableCell>{getStatusTranslation(ticket.estado)}</TableCell>
              <TableCell>{ticket.comprador ? ticket.comprador.nombre : null}</TableCell>
              <TableCell>
                {ticket.vendedor
                  ? `${ticket.vendedor.nombre} (${ticket.vendedor.descripcion})`
                  : null}
              </TableCell>
              {showActions && (
                <TableCell>
                  <div className='flex items-center gap-1'>{renderActionButtons(ticket)}</div>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Pagination
        className='pagination-bar'
        totalCount={totalCount}
        onPageChange={onPageChange}
        currentPage={currentPage}
        pageSize={itemsPerPage}
      />
    </>
  );
}

export default TicketTable;
